import {
  Card,
  Divider,
  IconButton,
  List,
  ListItem,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Delete } from "@mui/icons-material";
import NullCheck from "../../../components/NullCheck";

const ClientItems = ({ itemList, setItemList, clientData }) => {
  const { t } = useTranslation();

  const addProd = (selectedItem) => {
    setItemList((list) => [...list, selectedItem]);
  };

  const removeProd = (id) => {
    let newList = [...itemList];
    newList = newList.filter((prod, index) => index !== id);
    setItemList(newList);
  };

  const changeItemText = (data) => {
    const text = data?.text;
    const indexItem = data?.indexItem;
    let newList = [...itemList];
    const item = newList[indexItem].split("-")[0];
    newList[indexItem] = `${item} - ${text}`;

    setItemList(newList);
  };

  if (!clientData) return;

  return (
    <Stack paddingY={2}>
      <Stack direction="row" gap={2}>
        <NullCheck valueForCheck={clientData?.items?.length > 0}>
          <Stack>
            <Typography fontSize={11}>
              {t("SELECT_ITEMS")}:
            </Typography>

            <Select
              sx={{ width: 200, paddingX: 1 }}
              MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
              size="small"
              onChange={(e) => addProd(e.target.value)}
            >
              {clientData?.items.map((item, index) => {
                return (
                  item?.isWebSale && (
                    <MenuItem sx={{ minWidth: 200 }} key={index} value={item.name}>
                      <Typography>{item.name}</Typography>
                    </MenuItem>
                  )
                );
              })}
            </Select>
          </Stack>
        </NullCheck>

      </Stack>

      <List
        sx={{
          width: "100%",
          position: "relative",
          overflow: "auto",
          "& ul": { padding: 0 },
        }}
        subheader={<li />}
      >
        {itemList?.length > 0
          ? itemList?.map((item, index) => (
            <Fragment key={index}>
              <ListItem sx={{ paddingX: 0 }}>

                <Card sx={{ width: "100%", border: '1px solid #000' }}>

                  <Stack spacing={1} pb={1} px={1}>
                    <Typography textAlign='start' variant="subtitle2" fontWeight="bold">
                      {item?.split("-")[0]}
                    </Typography>

                    <TextField
                      placeholder={t("DESC_PROBLEM")}
                      multiline
                      rows={5}
                      onChange={(e) =>
                        changeItemText({ text: e.target.value, indexItem: index })
                      }
                    />
                  </Stack>

                  <Stack
                    padding={0.5}
                    alignItems='end'
                    borderTop='1px solid #000'
                    bgcolor="secondary.light"
                  >
                    <IconButton onClick={() => removeProd(index)}>
                      <Delete color="error" />
                    </IconButton>
                  </Stack>


                </Card>
              </ListItem>
              <Divider />
            </Fragment>
          ))
          : null
        }
      </List>
    </Stack>
  );
};
export default ClientItems;
